"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgVolleyFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M11.873 2c-.599 1.529-.846 3.066-.764 4.532 3.371-.488 7.086.06 10.258 1.958A10.004 10.004 0 0011.873 2zM9.662 2.275C8.56 5.88 9.065 9.567 11.141 12.517a9.952 9.952 0 01-2.057 1.418C6.849 10.828 6.02 6.84 7.139 3.26a9.935 9.935 0 012.523-.984zM21.982 11.387c-3.014-2.565-6.97-3.394-10.553-2.88a9.157 9.157 0 001.13 2.534c2.353-.158 4.457.13 6.364 1.02a11.257 11.257 0 012.875 1.949 10.05 10.05 0 00.184-2.623zM21.105 16.141c-.802-.863-1.633-1.52-2.511-2.005-2.215 3.909-6.1 6.387-11 6.843A9.959 9.959 0 0012 22c4.046 0 7.53-2.403 9.105-5.859z' }),
    react_1.default.createElement("path", { d: 'M4.882 19.024c5.438.327 9.59-1.877 11.841-5.65-.974-.27-2.037-.392-3.218-.372-1.72 1.842-3.578 2.984-5.662 3.538-1.445.384-2.962.475-4.567.35.439.783.98 1.5 1.606 2.134zM2.393 14.786c1.78.24 3.341.212 4.756-.133-1.854-2.786-2.785-6.176-2.434-9.503A9.965 9.965 0 002 12c0 .967.137 1.902.393 2.786z' }))); };
exports.default = SvgVolleyFilled;
//# sourceMappingURL=VolleyFilled.js.map